import { useMemo } from 'react';
import { flavorsAssignedColorTokens, themeAssignedColorTokens } from '../theme';
import { capitalizeFirstLetter } from '../lib/utils';
const getFlavorTokenOverrideIntent = (flavorTokens, theme, accent)=>{
    const themeTokenOverrideIntent = [];
    if (flavorTokens.tokens) {
        themeTokenOverrideIntent.push(flavorTokens.tokens);
    }
    const themeToken = theme && flavorTokens[theme];
    if (themeToken) {
        themeTokenOverrideIntent.push(themeToken);
    }
    if (accent) {
        const accentToken = flavorTokens[accent];
        if (accentToken) {
            themeTokenOverrideIntent.push(accentToken);
        }
        if (theme) {
            const accentTheme = `${accent}${capitalizeFirstLetter(theme)}`;
            const accentThemeToken = flavorTokens[accentTheme];
            if (accentThemeToken) {
                themeTokenOverrideIntent.push(accentThemeToken);
            }
        }
    }
    return themeTokenOverrideIntent;
};
const getThemeTokens = (theme)=>{
    return [
        themeAssignedColorTokens[`${theme}Helm`],
        themeAssignedColorTokens[`${theme}Sail`]
    ].filter((assignedTokens)=>assignedTokens !== undefined);
};
const getFlavorTokens = (flavor, theme, accent)=>{
    const flavorTokenOverrideIntent = [];
    const flavorTokens = flavorsAssignedColorTokens[flavor];
    if (flavorTokens) {
        flavorTokenOverrideIntent.push(...getFlavorTokenOverrideIntent(flavorTokens, theme, accent));
    }
    const flavorSailTokens = flavorsAssignedColorTokens[`${flavor}Sail`];
    if (flavorSailTokens) {
        flavorTokenOverrideIntent.push(...getFlavorTokenOverrideIntent(flavorSailTokens, theme, accent));
    }
    return flavorTokenOverrideIntent;
};
export const useHelmTheme = ({ theme, flavor, accent })=>{
    return useMemo(()=>{
        const themeTokenOverrideIntent = [];
        if (theme) {
            themeTokenOverrideIntent.push(...getThemeTokens(theme));
        }
        if (flavor) {
            themeTokenOverrideIntent.push(...getFlavorTokens(flavor, theme, accent));
        }
        return themeTokenOverrideIntent.filter(Boolean);
    }, [
        theme,
        flavor,
        accent
    ]);
};

//# sourceMappingURL=useHelmTheme.js.map